<template>
      <div class="row">
        <div class="col-md-12">

        </div>
        <div class="col-md-4 mb-2">
            <div class="form-inline">
                <label class="mr-2">Showing</label>
                <select class="form-control" v-model="meta.per_page" @change="loadPerPage">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
                <label class="ml-2">Entries</label>
            </div>
        </div>
      
        <div class="col-md-4 offset-md-4"> 
                <div class="form-inline float-right" v-if="is_search_by_date">
                <label class="mr-2">Search by Date</label>
                <input type="date" class="form-control" @input="search">
            </div>
        </div>

        <div class="col-md-12">
            <CDataTable striped hover bordered :items="items" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" show-empty>
               <template #firstname="{item}">
                <td v-if="item.firstname"><router-link >{{item.firstname + ' ' + item.lastname}}</router-link></td>
                <td v-else></td>
              </template>
               <!-- <template #dob="{item}">
                  <td v-if="item.dob == null"> {{ '-' }}  </td>
                <td v-else> {{item.dob}} </td>
              </template>   
               
              <template #phone="{item}">
                  <td v-if="item.phone == null||item.phone == ''"> {{ '-' }}  </td>
                <td v-else> {{item.phone}} </td>
              </template>  
              <template #email="{item}">
                  <td v-if="item.email == null || item.email == ''"> {{'-'}} </td>
                <td v-else> {{item.email}} </td>
              </template>  
              <template #location="{item}">
                  <td v-if="item.location == null||item.location == ''"> {{ '-' }}  </td>
                <td v-else> {{item.location}} </td>
              </template>  -->
              <template #is_active="{item}">
                <td>
                    <CBadge v-if="item.is_active == 0" color="danger">No</CBadge>
                    <CBadge v-if="item.is_active == 1" color="success">Yes</CBadge>
                </td>
              </template>
              <template #created_at="{item}">
                <td v-if="item.created_at =='0000-00-00'"> {{ '-'}} </td>
                <td v-else>{{frontEndDateFormat(item.created_at)}} </td>
              </template>              
              <!-- <template #service_date="{item}">
                <td v-if="item.service_date =='0000-00-00'"> {{ '-'}} </td>
                <td v-else>{{frontEndDateFormat(item.service_date)}} </td>
              </template>
              <template #service_type="{item}">
                  <td v-if="item.service_type == null || item.service_type == '' "> {{ '-' }}  </td>
                <td v-else> {{item.service_type}} </td>
              </template>   -->
              <template #action="{item}">
                <td v-if="item.status == 'member'" style='width:250px'> 
                    <CDropdown
                        placement="bottom-end"
                        :offset="[-70, -35]"
                        toggler-text="Action"
                        color="primary"
                        class="m-2 d-inline-block"
                        size="sm"
                        >
                        <CDropdownItem @click="showPeople(item.uuid)">Show Personal Information</CDropdownItem>
                        <!-- <CDropdownItem @click="editPeople(item.uuid)">Edit Personal Information</CDropdownItem>
                        <CDropdownItem @click="showMember(item.member_id)">Show Member Detail</CDropdownItem>
                        <CDropdownItem v-if="item.portal_access != 1" @click="setPortalAccess(item.uuid)">Grant Access Portal</CDropdownItem>
                        <CDropdownItem @click="resetPasswordPeople(item.uuid)">Reset Password</CDropdownItem>
                        <CDropdownItem v-if="item.is_active == 1" @click="deactivate(item.uuid)">Deactivate</CDropdownItem>
                        <CDropdownItem v-if="item.is_active == 0" @click="reactivate(item.uuid)">Reactivate</CDropdownItem> -->
                    </CDropdown>
                </td>    
                <td v-else-if="item.status == 'newcomer'" style='width:250px'> 
                    <CDropdown
                        placement="bottom-end"
                        :offset="[-70, -35]"
                        toggler-text="Action"
                        color="primary"
                        class="m-2 d-inline-block"
                        size="sm"
                        >
                        <CDropdownItem @click="showPeople(item.uuid)">Show Personal Information</CDropdownItem>
                        <!-- <CDropdownItem @click="editPeople(item.uuid)">Edit Personal Information</CDropdownItem>
                        <CDropdownItem @click="showNewcomer(item.newcomer_id)">Show Newcomer Detail</CDropdownItem>
                        <CDropdownItem @click="convertToMember(item.uuid)">Convert to Member</CDropdownItem>
                        <CDropdownItem @click="convertToVisitor(item.uuid)">Duplicate to Visitor</CDropdownItem>
                        <CDropdownItem @click="resetPasswordPeople(item.uuid)">Reset Password</CDropdownItem>
                        <CDropdownItem v-if="item.is_active == 1" @click="deactivate(item.uuid)">Deactivate</CDropdownItem>
                        <CDropdownItem v-if="item.is_active == 0" @click="reactivate(item.uuid)">Reactivate</CDropdownItem> -->
                    </CDropdown>
                </td> 
                <td v-else-if="item.status == 'visitor'" style='width:250px'> 
                    <CDropdown
                        placement="bottom-end"
                        :offset="[-70, -35]"
                        toggler-text="Action"
                        color="primary"
                        class="m-2 d-inline-block"
                        size="sm"
                        >
                        <CDropdownItem @click="showPeople(item.uuid)">Show Personal Information</CDropdownItem>
                        <!-- <CDropdownItem @click="editPeople(item.uuid)">Edit Personal Information</CDropdownItem> -->
                        <!-- <CDropdownItem @click="showVisitor(item.visitor_id)">Show Visitor Detail</CDropdownItem> -->
                        <!-- <CDropdownItem @click="convertToMember(item.uuid)">Convert to Member</CDropdownItem>
                        <CDropdownItem @click="resetPasswordPeople(item.uuid)">Reset Password</CDropdownItem>
                        <CDropdownItem v-if="item.is_active == 1" @click="deactivate(item.uuid)">Deactivate</CDropdownItem>
                        <CDropdownItem v-if="item.is_active == 0" @click="reactivate(item.uuid)">Reactivate</CDropdownItem> -->
                    </CDropdown>
                </td> 
              </template>

            </CDataTable>   
        </div>

        <div class="col-md-6">
            <p>Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} items</p>
        </div>
      
        <div class="col-md-6">
            <b-pagination
                v-model="meta.current_page"
                :total-rows="meta.total"
                :per-page="meta.per_page"
                align="right"
                @change="changePage"
                aria-controls="dw-datatable"
            ></b-pagination>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment';
import service from '@/services/service'
import axios from 'axios'
import store from '@/store.js'

export default {
  name: 'Table',
  props: {
    items: Array,
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
    items: {
        type: Array,
        required: true
    },
    fields: {
        type: Array,
        required: true
    },
    meta: {
        required: true
    },
    btn_show: {
        required: true
    },
    btn_edit: {
        required: true
    },
    btn_deactivate: {
        required: true
    },
    btn_reactivate: {
        required: true
    },
    btn_destroy: {
        required: true
    },
    is_uuid: {
        required: true
    },
    is_search_by_date: {
        required: true
    },

  },
  data() {
      return {
          sortBy: null, 
          sortDesc: false, 
          deleteModal: false,
          selected: null,
          selectID: null,
          inc: 5,
      }
  },
    watch: {
        sortBy(val) {
            this.$emit('sort', {
                sortBy: this.sortBy,
                sortDesc: this.sortDesc
            })
        },
        sortDesc(val) {
            this.$emit('sort', {
                sortBy: this.sortBy,
                sortDesc: this.sortDesc
            })
        }
    },
   methods:{

   getPhoto(data){
        if (data){
            return axios.defaults.baseURL + '/getfile/memberphoto/' + data
        }else{
            return axios.defaults.baseURL + '/getfile/memberphoto/no_photo.jpg'
        } 
     
    }, 
    
      loadPerPage(val) {
          this.$emit('per_page', this.meta.per_page)
      },

      loadIsActive(val) {
          this.$emit('is_active', this.meta.is_active)
      },

      changePage(val) {
          this.$emit('pagination', val)
      },

      search: _.debounce(function (e) {
          this.$emit('search', e.target.value)
      }, 500),


      show: function (id) {
          this.$emit('show', id)
      },

      showPeople: function (id) {
          this.$emit('showPeople', id)
      },

      editPeople: function (id) {
          this.$emit('editPeople', id)
      },      

      showMember: function (id) {
          this.$emit('showMember', id)
      },

      showNewcomer: function (id) {
          this.$emit('showNewcomer', id)
      },      

      showVisitor: function (id) {
          this.$emit('showVisitor', id)
      },

      convertToMember: function (id) {
          this.$emit('convertToMember', id)
      },
      
      convertToVisitor: function (id) {
          this.$emit('convertToVisitor', id)
      },

      setPortalAccess: function (id) {
          this.$emit('setPortalAccess', id)
      },
 
      resetPasswordPeople: function (id) {
          this.$emit('resetPasswordPeople', id)
      }, 

      edit: function (id) {
          this.$emit('edit', id)
      },

      deactivate: function (id) {
        this.$emit('deactivate', id)
      },
      
      reactivate: function (id) {
        this.$emit('reactivate', id)
      },

      destroy: function (id) {
        this.$emit('destroy', id)
      },

      resetpassword: function (id) {
        this.$emit('resetpassword', id)
      },

      grantwebaccess: function (id) {
        this.$emit('grantwebaccess', id)
      },   

      converttomember: function (id) {
        this.$emit('converttomember', id)
      },     

      frontEndDateFormat: function(date) {
        return moment(date, 'YYYY-MM-DD').format('DD MMMM YYYY');
      },

  }
 
}
</script>
